// src/pages/AdminReports.jsx

import React, { useEffect, useState } from "react";
import api from "../api";

export default function AdminReports() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    loadReports();
  }, []);

  async function loadReports() {
    try {
      setLoading(true);
      setError("");

      const me = JSON.parse(
  localStorage.getItem("user") || "{}"
);

const { data } =
  await api.get(
    "/admin/reports",
    {
      headers: {
        "x-admin-email": me.email
      }
    }
  );

      setReports(data.reports || []);
    } catch (err) {

  console.error(
    "Failed to load reports",
    err
  );

  setError(
    err?.response?.data?.error ||
    "Access denied"
  );

} finally {
      setLoading(false);
    }
  }

  return (
    <div
      className="page-shell"
      style={{
        padding: 16,
        maxWidth: 900,
        margin: "0 auto"
      }}
    >
      <h1 style={{ marginBottom: 16 }}>
        Moderation Queue
      </h1>

      {loading && (
        <p>Loading reports...</p>
      )}
      {error && (
  <p
    style={{
      color: "#ef4444",
      fontWeight: 600,
      marginBottom: 12
    }}
  >
    {error}
  </p>
)}

      {!loading &&
 !error &&
 reports.length === 0 && (
  <p>No reports found.</p>
)}

      {!loading &&
        reports.map((r) => (
          <div
            key={r.id}
            style={{
              border: "1px solid #2a2f3a",
              borderRadius: 12,
              padding: 16,
              marginBottom: 12,
              background: "#0f1218"
            }}
          >
            <div style={{ marginBottom: 8 }}>
              <strong>Report ID:</strong> {r.id}
            </div>

            <div style={{ marginBottom: 8 }}>
              <strong>Status:</strong> {r.status}
            </div>

            <div style={{ marginBottom: 8 }}>
              <strong>Reason:</strong> {r.reason}
            </div>
            
            <div style={{ marginBottom: 8 }}>
  <strong>Author:</strong> {r.username}
</div>

<div style={{ marginBottom: 12 }}>
  <strong>Post:</strong>
  <div
    style={{
      marginTop: 4,
      whiteSpace: "pre-wrap"
    }}
  >
    {r.post_text || "[post deleted]"}
  </div>
</div>

{Array.isArray(r.media_urls) &&
  r.media_urls.length > 0 && (
    <div style={{ marginBottom: 12 }}>
      <strong>Media:</strong>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          marginTop: 8
        }}
      >
        {r.media_urls.map((url, i) => {

          const isVideo =
            url.toLowerCase().includes(".mp4");

          return isVideo ? (
            <video
              key={i}
              src={url}
              controls
              style={{
                width: "100%",
                borderRadius: 12
              }}
            />
          ) : (
            <img
              key={i}
              src={url}
              alt=""
              style={{
                width: "100%",
                borderRadius: 12,
                maxHeight: 400,
                objectFit: "cover"
              }}
            />
          );

        })}
      </div>
    </div>
)}

            <div style={{ marginBottom: 8 }}>
              <strong>Type:</strong> {r.target_type}
            </div>

            <div style={{ marginBottom: 8 }}>
              <strong>Reporter:</strong>

<div style={{ marginTop: 4 }}>
  {r.reporter_username}
</div>
            </div>


            <div
  style={{
    display: "flex",
    gap: 8,
    flexWrap: "wrap"
  }}
>
  {r.status === "pending" ? (
    <>
      <button
        className="btn btn-ghost"
        onClick={async () => {
          try {

            await api.post(
              `/admin/reports/${r.id}/dismiss`
            );

            await loadReports();

            alert("Report dismissed");

          } catch (err) {

            console.error(err);

            alert("Failed to dismiss report");

          }
        }}
      >
        Dismiss
      </button>

      <button
        className="btn btn-danger"
        onClick={async () => {

          if (
            !window.confirm(
              "Remove this post?"
            )
          ) {
            return;
          }

          try {

            await api.post(
              `/admin/reports/${r.id}/remove-post`
            );

            await loadReports();

            alert("Post removed");

          } catch (err) {

            console.error(err);

            alert("Failed to remove post");

          }
        }}
      >
        Remove Post
      </button>
    </>
  ) : (
    <div
      style={{
        fontWeight: 600,
        color:
          r.status === "resolved"
            ? "#22c55e"
            : "#94a3b8"
      }}
    >
      {r.status === "resolved"
        ? "✓ Resolved"
        : "✓ Dismissed"}
    </div>
  )}
</div>
          </div>
        ))}
    </div>
  );
}